import React, { useEffect, useState } from "react";
import {
  clickCheckRiskCountService,
  getViewDetailsNewReuestHistory,
  updatStatusAcceptFunctionaliy,
} from "./Actions";
import {
  Row,
  Col,
  Badge,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Toast,
} from "reactstrap";
import { useHistory, useLocation, Link } from "react-router-dom";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import Toaster from "../../common/Toaster";
import LoaderCustom from "../../common/LoaderCustom";
import FileUpload from "../FileUpload";
import SaveRiskUpload from "./common/SaveRiskUpload";
import TooltipCustom from "../../common/Tooltip";
import { useForm, Controller } from "react-hook-form";
import { userDetails } from "../../../helper";
import { reactLocalStorage } from "reactjs-localstorage";

const ViewNewRequestHistory = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idData = searchParams.get("id");
  // Use the id in your component logic
  const [getByIdData, setGetByIdData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);

  const [submitionLoading, setSubmitionLoading] = useState(false);
  const [remarkAccept, setRemarkAccept] = useState(false);
  const [approvalType, setApprovalType] = useState("");
  const userDetail = userDetails();


  const [remark, setRemark] = useState("");
  const [loader, setloader] = useState(false);
  const [formError, setFormError] = useState("");
  const history = useHistory();
  const [remarkReject, setRemarkReject] = useState(false);
  const [saveRiskFile, setSaveRiskFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (idData) {
      setLoading(true);

      // Simulate loading for 3 seconds
      const fetchDataWithDelay = async () => {
        await new Promise(resolve => setTimeout(resolve, 3000));

        try {
          const res = await getViewDetailsNewReuestHistory(idData);
          const userDataPotentialsupplier = res?.Data;
          const data = { ...userDataPotentialsupplier[0] };
          setGetByIdData(data);
          setLoading(false);
        } catch (error) {

          setLoading(false);
        }
      };

      fetchDataWithDelay();
    }
  }, [idData]);
  const [riskCount, setRiskCount] = useState(getByIdData?.RiskCount);
  const {
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return empty string if the date is not provided
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero if needed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const handleDownload = (file) => {
    if (file) {
      // Create a hidden anchor element to trigger the download
      const link = document.createElement("a");

      if (typeof file === "string") {
        // If it's a string and starts with 'http', assume it's a URL
        link.href = file;
        // } else if (typeof file === 'string') {
        //     // If it's a string, assume it's a base64 string
        //     
        //     return;
        // } else if ('base64String' in file && 'fileType' in file) {
        //     // If it's a DownloadableFile object, use its properties
        //     const blob = base64toBlob(file.base64String, file.fileType);
        //     link.href = URL.createObjectURL(blob);
        // } else if (file instanceof File) {
        //     // If it's a File object, use it directly
        //     link.href = URL.createObjectURL(file);
      } else {
        // Handle other cases or throw an error

        return;
      }

      link.target = "_blank";
      link.download = "downloadedFile";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const onPopupConfirm = () => {
    setIsModalOpen(false);
    setShowPopup(false);
    setRemarkAccept(true);
  };
  const closePopUp = () => {
    setShowPopup(false);
    setRemarkAccept(false);
    setIsModalRejectOpen(false);
    setRemarkReject(false);
    setRemark('')
    setApprovalType("")
  };
  const onRejectConfirm = () => {
    setIsModalRejectOpen(false);
    setRemarkReject(true);
  };
  const remarkRejectPopup = () => {
    handleOk(false);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleAccept = () => {
    // Handle edit action
    toggleModal();
    // setIdData(props.data.supplierRepositoryRequestId);
    // setEmailData(props.data.emailAddress);
    // // setRemarkAccept(true); // Open the modal
    setRemarkAccept(true);
    setApprovalType("accept")
  };
  const popupInputData = (data) => {
    setRemark(data);
  };
  const handleReject = () => {
    setRemarkAccept(true); // Open the remark modal
    setApprovalType("reject")

  };
  const handleOk = async (approvalType) => {
    try {
      // Validate remark
      if (!remark.trim()) {
        setFormError("Please enter a remark");
        return;
      }

      // Extract user ID from data
      // const userId = 7;

      // // Validate user ID
      // if (!userId) {
      //   
      //   return;
      // }

      // Set loading state to true before API call

      setloader(true);
      const userDetail = userDetails();
      // Extract user ID from data
      const userId = userDetail?.EmployeeId;
      // Fetch updated users list instantly

      // Prepare request data
      const status = approvalType == "reject" ? 3 : 2;
      const requestData = {
        supplierRepositoryRequestId: idData,
        ActionTakenByEmployeeId: parseInt(userId), // Parse userId to integer
        RequestStatus: status,
        SaveriskDocumentAttachment: saveRiskFile || null,
        Remark: remark,
        Email: getByIdData?.Email,
      };

      // Call the API function to update the status
      const response = await updatStatusAcceptFunctionaliy(requestData);

      // Handle API response
      if (response) {
        // Display success notification
        Toaster.success(
          `The application has been ${approvalType === "accept" ? "accepted" : "rejected"
          } successfully.`
        );

        // Navigate to the desired route
        
        const receiverId = reactLocalStorage.getObject('receiverId');
        const hasValidReceiverId = receiverId !== null && receiverId !== undefined;
        reactLocalStorage.setObject('receiverId', null);


        history.push(hasValidReceiverId ? "/" : "/new-request-history");
      }

      // Reset loading state and modal states

      setloader(false);
      setRemark("");
      setRemarkAccept(false);
      setRemarkReject(false);
      setIsModalRejectOpen(false);
    } catch (error) {


      // Display error notification
      Toaster.error({
        message: "Error",
        description: "Failed to process the application. Please try again.",
      });

      // Reset loading state and modal states in case of error

      setloader(false);
      setRemark("");
      setRemarkAccept(false);
      setRemarkReject(false);
      setIsModalRejectOpen(false);
      setIsModalOpen(false);
    }
  };
  const handleCheckRiskClick = (event) => {
    event.preventDefault();
    // const reqDataCount = {
    //     supplierRepositoryRequestGuid: getByIdData.supplierRepositoryRequestGuid
    // };
    clickCheckRiskCountService(getByIdData.SupplierRepositoryRequestGuid)
      .then((response) => {
        // Handle the response if needed
        // notification.success({
        //     message: 'Risk Checked',
        //     description: response?.message
        // });
        setSubmitionLoading(false);
        setRiskCount(response?.Data || 0);
        //  router.push('/dashboard/new-request-history');
        window.open('https://www.saverisk.com/flogin.aspx', '_blank');
      })
      .catch((error) => {
        // Handle errors if needed

        Toaster.error(error?.response?.data.message);
      });
  };
  const handleSaveRiskUpload = (e, file) => {
    e.preventDefault(); // Prevents the default behavior of the event

    // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
    if (file.size <= 5 * 1024 * 1024) {
      const reader = new FileReader();
      reader.onload = (event) => {
        let base64String = event.target.result;

        // Remove the data type prefix
        base64String = base64String.replace(/^data:(.*?);base64,/, "");

        // Check if the file type is allowed
        const allowedFileTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ];
        const isTypeValid = allowedFileTypes.includes(file.type);

        if (!isTypeValid) {
          Toaster.error(
            "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
          );
          // Handle the case where the file type is not allowed
          return;
        }
        // Pass file name, base64String, and fileType to setGstinFile
        setSaveRiskFile({
          fileName: file.name,
          base64String,
          fileType: file.type,
        });
      };
      reader.readAsDataURL(file);
    } else {
      Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
      // Handle the case where the file size exceeds 5 MB
    }
  };
  const onPopupConfirmForRequestReview = () => {
    setShowPopup(true);
  };
  const onPopupConfirmForReject = () => {

    setIsModalRejectOpen(true)
  };
  const handleRemarkPopupConfirm = (remark) => {
    // 
    // return;
    if (!remark) {
      // setRemarkError("Please enter a remark");
      setRemarkAccept(true);
      // return;
    } else {
      setRemarkAccept(false);
      setShowPopup(true);
    }

    // onPopupConfirmForRequestReview();
  };
  const handleRemarkPopupReject = () => {
    if (!remark) {
      // setRemarkError("Please enter a remark");
      setRemarkReject(true);
      return;
    }
    setRemarkReject(false);
    onPopupConfirmForReject();
  };

  if (loader || submitionLoading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }

  if (loader || loading) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  return (
    <div>
      {showPopup && (
        <PopupMsgWrapper
          isOpen={showPopup}
          closePopUp={closePopUp}
          confirmPopup={() => handleOk(approvalType)}
          message={`Are you sure you want to ${approvalType} this application?`}
        />
      )}
      {remarkAccept && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkAccept}
          closePopUp={closePopUp}
          confirmPopup={() => handleRemarkPopupConfirm(remark)}
          header={"Remark"}
          isInputField={true}
        />
      )}
      {/* {isModalRejectOpen && (
        <PopupMsgWrapper
          isOpen={isModalRejectOpen}
          closePopUp={closePopUp}
          confirmPopup={handleOk(false)}
          message={`Are you sure you want to reject this application?`}
        />
      )}
      {remarkReject && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkReject}
          closePopUp={closePopUp}
          // confirmPopup={remarkRejectPopup}
          confirmPopup={handleRemarkPopupReject}
          header={"Remark"}
          isInputField={true}
        />
      )} */}
      <Row className={`filter-row-large`}>
        <Col md="4" className="mb-2">
          <h1>View Application Details</h1>
        </Col>
        <Col md="8" className="mb-3 d-flex justify-content-end">
          <button
            type="button"
            className={"apply mt-1"}
            onClick={() => window.history.back()}
          >
            <div className={"back-icon"}></div>Back
          </button>
        </Col>
      </Row>
      {!loading && !getByIdData ? (
        <LoaderCustom customClass="simulation-Loader" />
      ) : (
        ""
      )}
      <Row noGutters>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Row className="non-registered-supplier-details-right text-left">
            <Col xs={12} sm={6} md={6}>
              <Row noGutters>
                <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12}>
                  <h3 className="sd-common-heading">Company Details</h3>
                </Col>
              </Row>
              <Row noGutters className="hl-detail-column">
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Request Number</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details text-uppercase">
                    <strong> {getByIdData?.SupplierRepositoryRequestNo}</strong>
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Supplier Origin</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.SupplierOrigin}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Company Name</span>
                </Col>


                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.CompanyName}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Type of Establishment</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.TypeOfEstablishment}
                  </span>
                </Col>

                {getByIdData?.TypeOfEstablishment === "Company" && getByIdData?.SupplierOrigin === "Indian" && (
                  <>
                    {" "}
                    <Col md={12} className="hl-heading-details">
                      <span className="hl-title-details">CIN Number</span>
                    </Col>
                    <Col md={12} className=" hl-descmain-details">
                      <span className="hl-desc-details text-uppercase justify-content-between">
                        {getByIdData?.RelatedInputField}
                        {getByIdData?.SupplierOrigin === "Indian" &&

                          <> {getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl && (
                            <span>
                              <Button
                                onClick={() => {
                                  handleDownload(
                                    getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl
                                  );
                                }}
                                disabled={false}
                                title="Download"
                                className="hl-upload-btn hl-mb-0"
                              >
                                <div className="download mr-0"></div>
                              </Button>
                            </span>
                          )}</>

                        }
                      </span>

                    </Col>
                  </>
                )}
                {getByIdData?.TypeOfEstablishment === "LLP (Limited Liability Partnership)" && getByIdData?.SupplierOrigin === "Indian" && (
                  <>
                  {" "}
                  <Col md={12} className="hl-heading-details">
                    <span className="hl-title-details">LLP Number</span>
                  </Col>
                  <Col md={12} className=" hl-descmain-details">
                    <span className="hl-desc-details text-uppercase justify-content-between">
                      {getByIdData?.RelatedInputField}
                      {getByIdData?.SupplierOrigin === "Indian" &&

                        <> {getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl && (
                          <span>
                            <Button
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl
                                );
                              }}
                              disabled={false}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        )}</>

                      }
                    </span>

                  </Col>
                </>
                )}
                {getByIdData?.TypeOfEstablishment === "OPC (One Person Company)" && getByIdData?.SupplierOrigin === "Indian" && (
                  <>
                  {" "}
                  <Col md={12} className="hl-heading-details">
                    <span className="hl-title-details">OPC Number</span>
                  </Col>
                  <Col md={12} className=" hl-descmain-details">
                    <span className="hl-desc-details text-uppercase justify-content-between">
                      {getByIdData?.RelatedInputField}
                      {getByIdData?.SupplierOrigin === "Indian" &&

                        <> {getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl && (
                          <span>
                            <Button
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl
                                );
                              }}
                              disabled={false}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        )}</>

                      }
                    </span>

                  </Col>
                </>
                )}
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Year of Business Incorporation
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.YearOfBusinessIncorporation}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Contact Person Name</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.ContactPersonName}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Contact Person Designation
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.ContactPersonDesignation}
                  </span>
                </Col>
                {getByIdData?.PANNo && (
                  <>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">PAN Number</span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details text-uppercase justify-content-between pr-0">
                        {getByIdData?.PANNo}
                        {getByIdData?.PANCardAttachmentUrl && (
                          <Button
                            onClick={() => {
                              handleDownload(getByIdData?.PANCardAttachmentUrl);
                            }}
                            disabled={false}
                            title="Download"
                            className="hl-upload-btn hl-mb-0"
                          >
                            <div className="download mr-0"></div>
                          </Button>
                        )}
                      </span>
                    </Col>
                  </>
                )}
                {getByIdData?.SupplierOrigin === "Indian" &&
                  <>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">GSTIN Number</span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details text-uppercase justify-content-between pr-0">
                        {getByIdData?.GISTINNumber
                          ? getByIdData?.GISTINNumber
                          : "-"}
                        {getByIdData?.GISTINNumberAttachmentUrl && (
                          <Button
                            onClick={() => {
                              handleDownload(
                                getByIdData?.GISTINNumberAttachmentUrl
                              );
                            }}
                            disabled={false}
                            title="Download"
                            className="hl-upload-btn hl-mb-0"
                          >
                            <div className="download mr-0"></div>
                          </Button>
                        )}
                      </span>
                    </Col>
                  </>}



                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Type of Business</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.TypeOfBusiness}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Supplier Specialization
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.SupplierSpecialization}
                  </span>
                </Col>
                {getByIdData?.OtherSpecializationName && (
                  <>
                    <Col md={12} className="hl-heading-details">
                      <span className="hl-title-details">
                        Other Specialization
                      </span>
                    </Col>
                    <Col md={12} className="pr-6 hl-descmain-details">
                      <span className="hl-desc-details">
                        {getByIdData?.OtherSpecializationName}
                      </span>
                    </Col>
                  </>
                )}
                {getByIdData?.OtherSpecializationExplanation && (
                  <>
                    <Col md={12} className="hl-heading-details">
                      <span className="hl-title-details">
                        Explain Specialization
                      </span>
                    </Col>
                    <Col md={12} className="pr-6 hl-descmain-details">
                      <span className="hl-desc-details">
                        {getByIdData?.OtherSpecializationExplanation}
                      </span>
                    </Col>
                  </>
                )}

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details hl-multi-val"><span>Total Staff</span><span>Total Workers</span></span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details hl-multi-val">
                    <span>{getByIdData?.TotalStaff}</span> <span>{getByIdData?.TotalWorkers}</span>
                  </span>
                </Col>


                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Do you have any existing or past Supplier code?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className={`hl-desc-details ${getByIdData?.IsExistingSupplier === "No" ? " " : "text-uppercase"}`}>
                    {getByIdData?.IsExistingSupplier === "Yes"
                      ? getByIdData?.VendorCode
                      : getByIdData?.IsExistingSupplier}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Do you have another Sister Concern which is Supplying to Havells Group?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className={`hl-desc-details ${getByIdData?.HasSisterConcernWithQRG === "No" ? " " : "text-uppercase"}`}>
                    {getByIdData?.HasSisterConcernWithQRG === "Yes"
                      ? getByIdData?.SisterConcernWithQRGVendorCode
                      : getByIdData?.HasSisterConcernWithQRG}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details d-flex align-items-center"
                >
                  <span className="hl-title-details">
                    Do you have another Relationship with any Havells Employees?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-descmain-details"
                >
                  <span className={`hl-desc-details d-block pe-0 ps-0 ${getByIdData?.HasRelationWithQRGEmployees === "No" ? "ps-3" : ""}`}>
                    {getByIdData?.HasRelationWithQRGEmployees ===
                      "Yes" ? (
                      <>
                        <p className="hl-multi-val d-flex hl-descmain-details pb-2 mb-2 mw-100">
                          <span className="w-50 ps-3">{getByIdData?.QRGEmployeeName}</span>
                          <span className="w-50 ps-2 ps-3">
                            {getByIdData?.HasRelationWithQRGEmployees ===
                              "Yes"
                              ? getByIdData?.Relation
                              : getByIdData?.HasRelationWithQRGEmployees}
                          </span>
                        </p>
                        <p className="hl-multi-val d-flex mt-2 w-100">
                          <span className={`w-50 ps-3 ${getByIdData?.HasRelationWithQRGEmployees === "No" ? " " : "text-uppercase"}`}>
                            {getByIdData?.HasRelationWithQRGEmployees ===
                              "Yes"
                              ? getByIdData?.QRGEmployeeCode
                              : getByIdData?.HasRelationWithQRGEmployees}
                          </span>
                          <span className="w-50 ps-3">
                            {getByIdData?.QRGEmployeeLocation}
                          </span>
                        </p>
                      </>
                    ) : (
                      getByIdData?.HasRelationWithQRGEmployees
                    )}
                  </span>
                </Col>
                {getByIdData?.SupplierOrigin === "Indian" && (
                  <>
                    {getByIdData?.IsRegisteredUnderMSMEDAct && (
                      <>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details"
                        >
                          <span className="hl-title-details">
                            Is your Organization Registered under Micro, Small, or Medium Enterprises (MSMED Act 2006)
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-descmain-details pe-0 ps-0"
                        >
                          <span className="hl-desc-details hl-multi-val pe-0 ps-0">
                            {getByIdData?.IsRegisteredUnderMSMEDAct ===
                              "Yes" ? (
                              <>
                                <span className="w-50 ps-3">
                                  {getByIdData?.IsRegisteredUnderMSMEDAct ===
                                    "Yes"
                                    ? getByIdData?.OrganizationType
                                    : getByIdData?.IsRegisteredUnderMSMEDAct}
                                </span>
                                <span className="w-50 ps-3">
                                  <span className="text-uppercase">{getByIdData?.MSMERegistrationNo}</span>
                                </span>
                                {getByIdData?.RegisteredUnderMSMEDActAttachmentUrl && (
                                  <span>
                                    <Button
                                      onClick={() => {
                                        handleDownload(
                                          getByIdData?.RegisteredUnderMSMEDActAttachmentUrl
                                        );
                                      }}
                                      disabled={false}
                                      title="Download"
                                      className="hl-upload-btn hl-mb-0"
                                    >
                                      <div className="download mr-0"></div>
                                    </Button>
                                  </span>
                                )}
                              </>
                            ) : (
                              getByIdData?.IsRegisteredUnderMSMEDAct
                            )}
                          </span>
                        </Col>
                      </>
                    )}
                  </>
                )}
                <>
                  {getByIdData?.SupplierOrigin === "Overseas" &&


                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Unified Social Credit Identifier (USCI)/ Business Licence Number
                      </span>
                    </Col>}
                  {getByIdData?.SupplierOrigin === "Overseas" &&
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span
                        className={`hl-desc-details justify-content-between pr-0 ${getByIdData?.CompanyRegistrationOrLicenseNo === "No"
                          ? " "
                          : "text-uppercase"
                          }`}
                      >
                        {getByIdData?.CompanyRegistrationOrLicenseNo
                          ? getByIdData?.CompanyRegistrationOrLicenseNo
                          : "-"}
                        {getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl && (
                          <span>
                            <Button
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.CompanyRegistrationOrLicenseAttachmentUrl
                                );
                              }}
                              disabled={false}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        )}
                      </span>
                    </Col>}
                </>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="hl-descmain-details"
                >
                  <span className="hl-title-details">
                    Do you have ISO 9001/IATF 16949?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className={`hl-desc-details justify-content-between pr-0 ${getByIdData?.HasISO9001OrIATF16949 === "No" ? " " : "text-uppercase"}`}>
                    {getByIdData?.HasISO9001OrIATF16949 === "Yes" ? (
                      <>
                        {getByIdData?.ISO9001IATFCertificateNumber}
                        {getByIdData?.ISO9001IATFCertificateNumberAttachmentUrl && (
                          <span>
                            <Button
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.ISO9001IATFCertificateNumberAttachmentUrl
                                );
                              }}
                              disabled={false}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        )}
                      </>
                    ) : (
                      getByIdData?.HasISO9001OrIATF16949
                    )}
                  </span>
                </Col>
                {/* {getByIdData?.HasISO9001OrIATF16949 === "Yes" && (
                  <>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        ISO Certificate Number
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details text-uppercase justify-content-between pr-0">
                        {getByIdData?.ISO9001IATFCertificateNumber}
                        {getByIdData?.ISO9001IATFCertificateNumberAttachmentUrl && (
                          <Button
                            onClick={() => {
                              handleDownload(
                                getByIdData?.ISO9001IATFCertificateNumberAttachmentUrl
                              );
                            }}
                            disabled={false}
                            title="Download"
                            className="hl-upload-btn hl-mb-0"
                          >
                            <div className="download mr-0"></div>
                          </Button>
                        )}
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Expiry Date</span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {formatDate(getByIdData?.ISO9001IATFExpiryDate)}
                      </span>
                    </Col>
                  </>
                )} */}
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="hl-descmain-details"
                >
                  <span className="hl-title-details">
                    Do you have a Factory License?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className={`hl-desc-details justify-content-between pr-0 ${getByIdData?.HasFactoryLicense === "No" ? " " : "text-uppercase"}`}>
                    {getByIdData?.HasFactoryLicense === "Yes" ? (
                      <>
                        {getByIdData?.FactoryCertificateNo}
                        {getByIdData?.FactoryFactoryLicenseAttachmentUrl && (
                          <span>
                            <Button
                              onClick={() => {
                                handleDownload(
                                  getByIdData?.FactoryFactoryLicenseAttachmentUrl
                                );
                              }}
                              disabled={false}
                              title="Download"
                              className="hl-upload-btn hl-mb-0"
                            >
                              <div className="download mr-0"></div>
                            </Button>
                          </span>
                        )}
                      </>
                    ) : (
                      getByIdData?.HasFactoryLicense
                    )}
                  </span>
                </Col>
                {/* {getByIdData?.HasFactoryLicense === "Yes" && (
                  <>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">
                        Factory License Number
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details text-uppercase justify-content-between pr-0">
                        {getByIdData?.FactoryCertificateNo}
                        {getByIdData?.FactoryFactoryLicenseAttachmentUrl && (
                          <Button
                            onClick={() => {
                              handleDownload(
                                getByIdData?.FactoryFactoryLicenseAttachmentUrl
                              );
                            }}
                            disabled={false}
                            title="Download"
                            className="hl-upload-btn hl-mb-0"
                          >
                            <div className="download mr-0"></div>
                          </Button>
                        )}
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Expiry Date</span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {formatDate(getByIdData?.FactoryLicenseExpiryDate)}
                      </span>
                    </Col>
                  </>
                )} */}
                <>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="hl-heading-details"
                  >
                    <span className="hl-title-details">
                      Explain Company Infrastructure/Service
                    </span>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="pr-6 hl-descmain-details"
                  >
                    <span className="hl-desc-details justify-content-between pr-0">
                      {getByIdData?.CompanyInfrastructureService
                        ? getByIdData?.CompanyInfrastructureService
                        : "-"}
                    </span>
                  </Col>
                </>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="hl-descmain-details"
                >
                  <span className="hl-title-details">
                    Company Profile
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="pr-6 hl-descmain-details"
                >
                  {getByIdData?.CompanyProfileAttachmentUrl ? (
                    <span className="hl-desc-details justify-content-end pr-0">
                      <Button
                        onClick={() => {
                          handleDownload(getByIdData.CompanyProfileAttachmentUrl);
                        }}
                        disabled={false}
                        title="Download"
                        className="hl-upload-btn hl-mb-0"
                      >
                        <div className="download mr-0"></div>
                      </Button>
                    </span>
                  ) : (
                    <span className="hl-desc-details">-</span>
                  )}
                </Col>
                <>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="hl-heading-details"
                  >
                    <span className="hl-title-details">Website</span>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className="pr-6 hl-descmain-details"
                  >
                    <span className="hl-desc-details">
                      {getByIdData?.CompanyProfileWebsite
                        ? getByIdData?.CompanyProfileWebsite
                        : "-"}
                    </span>
                  </Col>
                </>

                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="hl-descmain-details"
                >
                  <span className="hl-title-details">Last Year Turnover?</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details hl-multi-val">
                    {getByIdData?.LastYearTurnoverCurrencyName && (
                      <span>
                        {getByIdData?.LastYearTurnoverCurrencyName}
                      </span>
                    )}
                    <span>
                      {getByIdData?.LastYearTurnover}
                    </span>
                    {getByIdData?.LastYearTurnoverNumberScale && (
                      <span>
                        {getByIdData?.LastYearTurnoverNumberScale}
                      </span>
                    )}
                  </span>
                </Col>

                {getByIdData?.RequestStatus !== "Under Review" && (
                  // getByIdData?.ApplicationRequestAsignToEmployeeId && (
                  <>
                    {getByIdData?.RiskCount && (
                      <>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="hl-heading-details"
                        >
                          <span className="hl-title-details">Risk Count</span>
                        </Col>

                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="pr-6 hl-descmain-details"
                        >
                          <span className="hl-desc-details text-uppercase justify-content-between pr-0">
                            {getByIdData?.RiskCount}
                            {getByIdData?.RiskAssessmentDocumentAttachmentUrl && (
                              <Button
                                onClick={() => {
                                  handleDownload(
                                    getByIdData?.RiskAssessmentDocumentAttachmentUrl
                                  );
                                }}
                                disabled={false}
                                title="Download"
                                className="hl-upload-btn hl-mb-0"
                              >
                                <div className="download mr-0"></div>
                              </Button>
                            )}
                          </span>
                        </Col>
                      </>
                    )}
                  </>
                )}
              </Row>
              {getByIdData?.RequestStatus === "Under Review" && userDetail?.EmployeeId == getByIdData?.ApproverId &&
                getByIdData?.ApplicationRequestAsignToEmployeeId ? (
                <>
                  <div className="mr-auto d-flex">
                    <div className="pr-4 hl-saverisk-right">
                      <div count={riskCount ? riskCount : getByIdData?.RiskCount}>
                        <span>Saverisk Link Counts</span>
                        <Badge color="primary" pill className="ml-2 mr-2">
                          {riskCount ? riskCount : getByIdData?.RiskCount}
                        </Badge>
                      </div>
                      <Button
                        outline
                        disabled={!(getByIdData?.IsEnableSaveriskIcon === "true")}
                        onClick={handleCheckRiskClick}
                        className="mr-5 mt-1 hl-saverisk-link-btn btn-primary hl-acpt-btn"
                      >
                        Check Risk
                      </Button>
                    </div>
                    <div className="ml-5 hl-upload-file-left">
                      <lable className="mb-2">
                        Saverisk Document
                        <TooltipCustom
                          id="saveriskDocumentTooltip"
                          customClass="hl-com-profile hl-savrisk-tooltip"
                          tooltipText={<>Upload the risk assessment document - if found on Saverisk.</>
                          }
                        />
                      </lable>
                      <SaveRiskUpload
                        uploadClass="hl-svrisk-upload ml-0 mt-1"
                        uploaMainWrap="hl-upload-main hl-saverisk-document"
                        control={control}
                        name="ISO9001IATFCertificateNumberAttachment"
                        label="Upload ISO Certificate"
                        onFileChange={(e, file) => handleSaveRiskUpload(e, file)}
                        disabled={!(getByIdData?.IsEnableSaveriskIcon === "true")}
                        setFile={setSaveRiskFile}
                        uploadedFile={saveRiskFile}
                        setUplaodedFile={setSaveRiskFile}
                        allowedFileTypes={[
                          "application/pdf",
                          "application/msword",
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          "image/jpeg",
                          "image/jpg",
                          "image/png",
                          "application/vnd.ms-excel",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          "application/vnd.ms-powerpoint",
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                        ]}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

            </Col>
            <Col xs={12} sm={6} md={6}>
              <Row noGutters>
                <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12}>
                  <h3 className="sd-common-heading">Work Address</h3>
                </Col>
              </Row>
              <Row noGutters className="hl-detail-column">
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Building/Plot No.</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.BuildingPlotNo}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Street</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">{getByIdData?.Street}</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">City</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">{getByIdData?.City}</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">District</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.District ? getByIdData?.District : "-"}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">State/Region</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">{getByIdData?.State}</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Country</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.Country}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Postal Code/Zip Code</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.PostalCode}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Contact Number</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.MobileNo}
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    Primary Email Address
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    <a className="link" href={`mailto:${getByIdData?.Email}`}>
                      {getByIdData?.Email}
                    </a>
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    How did you hear About Us?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.HowDidYouHearAboutUs}
                  </span>
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">
                    What type of work address do you have?
                  </span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.WorkAddressType}
                  </span>
                </Col>
              </Row>
              <Row noGutters className="hl-detail-column hl-approver-comment mt-2">
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="hl-heading-details"
                >
                  <span className="hl-title-details">Application Status</span>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className="pr-6 hl-descmain-details"
                >
                  <span className="hl-desc-details">
                    {getByIdData?.RequestStatus}
                  </span>
                </Col>
                {getByIdData?.ApproverRemark && (
                  <>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="hl-heading-details"
                    >
                      <span className="hl-title-details">Approver Remark</span>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="pr-6 hl-descmain-details"
                    >
                      <span className="hl-desc-details">
                        {getByIdData?.ApproverRemark ? getByIdData?.ApproverRemark : "-"}
                      </span>
                    </Col>
                  </>
                )}
              </Row>

            </Col>
          </Row>
        </Col>
      </Row>
      {getByIdData?.RequestStatus === "Under Review" && userDetail?.EmployeeId == getByIdData?.ApproverId &&
        getByIdData?.ApplicationRequestAsignToEmployeeId ? (
        <>
          <Row className="sf-btn-footer hl-check-risk-footer no-gutters justify-content-end mt-3">
            <Col md={12} className="p-0">
              <div className="col-sm-12 bluefooter-butn d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="approve-button mr5 approve-hover-btn" onClick={handleAccept}>
                  <div className={'save-icon'}></div>
                  {'Approve'}
                </button>
                <button type={'button'} className="mr5 approve-reject-btn" onClick={handleReject}>
                  <div className={'cancel-icon-white mr5'}></div>
                  {'Reject'}
                </button>
              </div>
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default ViewNewRequestHistory;
